import { Form, InputGroup } from 'react-bootstrap'

export default function File(props) {

    const { label_name, disabled, name, onChange, onBlur, error, accept, mandatory, reference, tabIndex, spinner } = props

    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                {label_name === '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>}
                <InputGroup>
                    <Form.Control
                        ref={reference}
                        type="file"
                        size="sm"
                        disabled={disabled}
                        className='form_input'
                        name={name}
                        onChange={onChange}
                        onBlur={onBlur}
                        accept={accept}
                        tabIndex={tabIndex}
                    />
                    {spinner &&
                        <div className="ms-1 text-center">
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    }
                </InputGroup>
                {error}
            </Form.Group>
        </>
    )
}
